export const absurd = (_val: never): never => {
  throw new Error("This should never occur");
};
